module.exports = __webpack_public_path__ + "static/img/kc05.3198d57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kc05.png
// module id = gIRN
// module chunks = 1